import { LEAD_STATUSES } from "@/lib/constants";

export default function StatsGrid({ stats, activeFilter, onToggleFilter }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-px border-l border-t border-[rgba(255,255,255,0.08)] mb-8">
      <div className="border-r border-b border-[rgba(255,255,255,0.08)] p-5">
        <div className="overline">Gesamt</div>
        <div className="font-display text-3xl mt-2">{stats.total}</div>
      </div>
      {LEAD_STATUSES.map((s) => (
        <button
          key={s.value}
          type="button"
          onClick={() => onToggleFilter(s.value)}
          className={`text-left border-r border-b border-[rgba(255,255,255,0.08)] p-5 hover:bg-[#0B0F10] transition-colors ${
            activeFilter === s.value ? "bg-[#0B0F10]" : ""
          }`}
          data-testid={`stat-${s.value}`}
        >
          <div className="overline text-[10px]">{s.label}</div>
          <div className="font-display text-2xl mt-2">
            {stats.by_status[s.value] || 0}
          </div>
        </button>
      ))}
    </div>
  );
}
